import { render } from "./CookieInfo.vue?vue&type=template&id=5d1ca3e5"
import script from "./CookieInfo.vue?vue&type=script&lang=js"
export * from "./CookieInfo.vue?vue&type=script&lang=js"

import "./CookieInfo.vue?vue&type=style&index=0&id=5d1ca3e5&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__